/* Fashion Pret: remove surcharge lines left by the retired Afterpay cart flow. */
(function () {
  var feeProductId = 7930103562291;
  var feeVariantIds = [
    44771836690483, 44771836723251, 44771836756019, 44771836788787,
    44771836821555, 44771836854323, 44771836887091, 44771836919859,
    44771836952627, 44771836985395, 44771837018163, 44771837050931,
    44771837083699, 44771837116467, 44771837149235, 44771837182003,
    44771837214771, 44771837247539, 44771837280307, 44771837313075,
    44771837345843, 44771837378611, 44771837411379, 44771837444147,
    44771837476915, 44771837509683, 44771837542451, 44771837575219,
    44771837607987, 44771837640755, 44771837673523
  ];

  function isRetiredFee(item) {
    return Number(item.product_id) === feeProductId || feeVariantIds.indexOf(Number(item.id)) !== -1;
  }

  function refreshCartUi() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function removeRetiredFee() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var updates = {};
        cart.items.filter(isRetiredFee).forEach(function (item) { updates[item.key] = 0; });
        if (!Object.keys(updates).length) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (response.ok) refreshCartUi();
        });
      })
      .catch(function () {
        /* A transient cart request failure should never interrupt storefront use. */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeRetiredFee, { once: true });
  } else {
    removeRetiredFee();
  }
})();
